import { Button, Grid } from "@mui/material";
import { useState } from "react";
import { downloadFromApiPost } from "../../common/download";
import { createEntityStore } from "../../common/entityStore";
import { propCustomEnumField, propDateField, propSimpleEnumField, propTextField } from "../../common/entityStoreForm";
import { propNotZero, propRequired } from "../../common/entityStoreValidators";
import { EnumItemDto, orderTypes } from "../../common/enum";
import { createListStore } from "../../common/listStore";
import { ClearButton } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";

export function TmOrdersReportPage() {
    const [useStore] = useState(() => createEntityStore<TmOrdersReportParamsDto>({
        path: "reports/tmOrdersReport",
        data: getNewData(),
        fetchOnInit: false,
        propValidators: [
            propRequired("tmProjectId"),
            propNotZero("tmProjectId"),
        ]
    }));

    const { isSaveDisabled } = useStore(p => ({ isSaveDisabled: p.isSaveDisabled }));
    const [isExporting, setIsExporting] = useState(false);

    function getNewData(): TmOrdersReportParamsDto {
        return {
            fromDate: null,
            toDate: null,
            tmProjectId: 0,
            orderType: "",
            mediaCode: "",
        };
    }
    function clear() {
        useStore.getState().setClientData(getNewData());
    }
    async function doExport() {
        useStore.getState().enableValidation();

        if (useStore.getState().isSaveDisabled) {
            return;
        }

        try {
            setIsExporting(true);
            await downloadFromApiPost(`reports/tmOrderReports/xlsx`, useStore.getState().clientData);
        } finally {
            setIsExporting(false);
        }
    }

    const [useTmProjectStore] = useState(() => createListStore<EnumItemDto>({
        path: "reports/tmOrderReports"
    }));

    return <>
        <PageTitle title="TM Orders report" />
        <Grid container columnSpacing={2}>
            <Grid item xs={4} md={3}>{propCustomEnumField(useStore)("tmProjectId", "TM projekt", useTmProjectStore, {
                getId: p => p.id, getName: p => `${p.code} ${p.name}`,
            })}</Grid>
            <Grid item xs={4} md={1}>{propTextField(useStore)("mediaCode", "Media code")}</Grid>
            <Grid item xs={4} md={1}>{propSimpleEnumField(useStore)("orderType", "Order type", orderTypes, { addAll: true })}</Grid>
            <Grid item xs={4} md={1}>{propDateField(useStore)("fromDate", "fromDateFormatted", "From date")}</Grid>
            <Grid item xs={4} md={1}>{propDateField(useStore)("toDate", "toDateFormatted", "To date")}</Grid>
            <ClearButton onClick={clear} disabled={isExporting} />
            <Grid item xs={12}><Button onClick={doExport} disabled={isExporting || isSaveDisabled}>Export</Button></Grid>
        </Grid>
    </>;
}

interface TmOrdersReportParamsDto {
    fromDate: string | null;
    toDate: string | null;
    tmProjectId: number | null;
    orderType: string;
    mediaCode: string;
    mailIdFormatted?: string;
    fromDateFormatted?: string;
    toDateFormatted?: string;
};
